<template>
    <v-app>
        <!-- sidebar component -->
        <EKAside />
        <!-- navbar component -->
        <EkNavbar />
        <!-- Sizes your content based upon application components -->
        <v-main class="light">
            <!-- <img src="/media/svg/aside-icon/white-musk-top.svg" class="musk-corner musk-top-corner">
            <img src="/media/svg/aside-icon/white-musk-bottom.svg" class="musk-corner musk-bottom-corner"> -->
            <transition transition="v-scroll-y-transition">
                <router-view></router-view>
            </transition>
        </v-main>
    </v-app>
</template>
<style lang="scss" scoped>
.musk-corner {
    position: fixed;
    right: 55px;
    width: 60px;
    z-index: 1;
}
.musk-top-corner {
    top: -2px;
}
.musk-bottom-corner{
    bottom: -2px;
}

</style>
<script>
import EKAside from "./aside";
import EkNavbar from "./navbar";
import { mapActions } from 'vuex';
export default {
    data: () => ({
    }),
    components: {
        EKAside,
        EkNavbar
    },
    created(){
        this.$store.dispatch('setBreadcrumbs', [{
            text: 'الرئيسية',
            disabled: false,
            href: 'dashboard',
        }]);
    }
};
</script>
